declare global {
    interface DateConstructor {
      dateFormat(repDate: Date): string;
    }
  }

  Date.dateFormat = function(repDate: Date) {
    /* return repString.replace(/{(\d+)}/g, function(match, number) { 
      return typeof args[number] != 'undefined'
        ? args[number]
        : match
      ;
    }); */
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "numeric",day: "numeric",
      hour: "numeric",
      minute: "numeric",
    };
    
    return new Intl.DateTimeFormat("en-us", options).format(repDate);
  };
  
  export {}